import { h, Fragment } from "preact";
import { useState, useEffect } from "preact/hooks";
import MiniCartEmpty from "./mini-cart-empty";
import MiniCartQuotes from "./mini-cart-quotes";
import cartItemTypes from "../../helpers/cartItemTypes";
import MiniCartItemGroup from "./mini-cart-item-group";
import firstEligibleDiscountMessage from "./firstEligibleDiscountMessage";

export default function MiniCartContent({
  message,
  emptyMessage,
  swatchWarning,
  mixedSwatchTypesWarning,
  emptyCtaCopy,
  emptyCtaUrl,
  swatchLimitEach,
  showQuotes,
  quotesUrl,
  countryCode,
}) {
  const [cartData, setCartData] = useState(window.cartData);

  useEffect(() => {
    const onCartUpdated = (e) => {
      setCartData(e.detail.cartData);
    };

    document.addEventListener("cart:updated", onCartUpdated);

    return () => document.removeEventListener("cart:updated", onCartUpdated);
  }, [setCartData]);

  const cartItems = cartData?.items || [];
  const cartItemsByBundle = {};
  const unbundledCartItems = [];

  cartItems.forEach((item) => {
    const discountMessage = firstEligibleDiscountMessage(
      item.additionalData?.merchandise?.discountMessages,
    );

    const bundleName = discountMessage?.handle;

    if (bundleName) {
      if (!(bundleName in cartItemsByBundle)) {
        cartItemsByBundle[bundleName] = [];
      }

      cartItemsByBundle[bundleName].push(item);
    } else {
      unbundledCartItems.push([item]);
    }
  });

  const cartItemGroups = [
    ...Object.values(cartItemsByBundle),
    ...unbundledCartItems,
  ];

  const showStockAttribute = countryCode === "AU";
  const { mixed, nonSwatch } = cartItemTypes(cartItems);

  const swatchWarningText = mixed
    ? nonSwatch
      ? swatchWarning
      : mixedSwatchTypesWarning
    : null;

  const shouldSubdue = (item) => {
    const isSwatch = item.properties?._is_swatch === "true";
    const isRug = item.properties?._swatch_type === "rug";

    if (mixed && isSwatch && (nonSwatch || !isRug)) return true;

    return false;
  };

  if (cartItems.length === 0)
    return (
      <div class="mini-cart__empty">
        {message && <div className="mini-cart__message">{message}</div>}
        <MiniCartEmpty
          emptyMessage={emptyMessage}
          emptyCtaCopy={emptyCtaCopy}
          emptyCtaUrl={emptyCtaUrl}
        />
      </div>
    );

  return (
    <>
      {message && <div className="mini-cart__message">{message}</div>}
      <div className="mini-cart__items">
        {cartItemGroups.map((itemGroup) => (
          <MiniCartItemGroup
            key={itemGroup.map(({ id }) => id).join()}
            items={itemGroup}
            currency={cartData.currency}
            swatchLimitEach={swatchLimitEach}
            showStockAttribute={showStockAttribute}
            shouldSubdue={shouldSubdue}
          />
        ))}
        <div className="mini-cart__footer">
          {swatchWarningText && (
            <div
              className="mini-cart__swatch-warning"
              dangerouslySetInnerHTML={{
                __html: swatchWarningText,
              }}
            ></div>
          )}
          <div className="mini-cart__subtotal">
            <div className="mini-cart__subtotal-label">
              {window.localeStrings.cart.subtotal}
            </div>
            <div className="mini-cart__subtotal-value">
              {window.formatMoney(
                cartData.items_subtotal_price / 100,
                false,
                cartData.currency,
              )}
            </div>
          </div>
          <input type="hidden" name="checkout" />
          <a
            href={cartData.checkout_url}
            className="mini-cart__checkout button button--black button--full"
          >
            {window.localeStrings.cart.checkout}
          </a>
          {showQuotes && <MiniCartQuotes quotesUrl={quotesUrl} />}
        </div>
      </div>
    </>
  );
}
